export class UpdateCommissionsUiModel {

    public id: number;
    public report_type: string;
    public feed_type: string;
    public user_type: string;
    public page_name: string;
    public page_desc: string;
    public grid_name: string;
    public order_by: number;
    public saleschannel: string;
    public commplanid: number;
    public kpi_id: number;
    public created_by: string;
    public updated_by: string;
    public created_dt: Date;
    public updated_dt: Date;
    public status: string;
    public query: string;
    public effective_date: Date;

    public headerid: number;
    public configid: number;
    public pagename: string;
    public datakey: string;
    public margin: string;
    public pagenav: string;
    public colspancnt: number;
    public colorder: number;
    public istotalview: boolean = false;
    public ishyperlinkview: boolean = false;
    public isdisputeview: boolean = false;
    public header_created_by: string;
    public header_updated_by: string;
    public header_created_dt: Date;
    public header_updated_dt: Date;
    public header_saleschannel: string;
	public header_commplanid: number;
	public header_kpiid: number;

    public buttonid: number;
    public buttonconfigid: number;
    public button_position: string;
    public button_name: string;
    public button_pagenav: string;
    public button_created_by: string;
    public button_created_dt: Date;
    public button_updated_by: string;
    public button_updated_dt: Date;

    public transid: number;
    public navsaleschannel: string;
	public navcommplanid: number;
	public kpiid: number;
    public kpitype: string;
    public feedtype: string;
    public pagenavigation: string;
    public trans_created_dt: Date;
    public trans_created_by: string;
    public trans_updated_dt: Date;
    public trans_updated_by: string;

    public kpi_name: string;
    public commission_plan: string;
    public field_value: string;
    public field_name: string;

    public dispute_close_dt: Date;

    constructor() {
        this.header_saleschannel = null;
        this.header_commplanid = null;
        this.header_kpiid = null;
        this.transid = null;
        this.navsaleschannel = null;
        this.navcommplanid = null;
        this.kpiid = null;
        this.kpitype = null;
        this.feedtype = null;
        this.pagenavigation = null;
        this.trans_created_dt = null;
        this.trans_created_by = null;
        this.trans_updated_dt = null;
        this.trans_updated_by = null;

        this.id = null;
        this.report_type = null;
        this.feed_type = null;
        this.user_type = null;
        this.page_name = null;
        this.page_desc = null;
        this.grid_name = null;
        this.order_by = null;
        this.saleschannel = null;
        this.commplanid = null;
        this.kpi_id = null;
        this.created_by = null;
        this.updated_by = null;
        this.created_dt = null;
        this.updated_dt = null;
        this.status = null;
        this.query = null;

        this.headerid = null;
        this.configid = null;
        this.pagename = null;
        this.datakey = null;
        this.margin = null;
        this.pagenav = null;
        this.colspancnt = null;
        this.colorder = null;
        this.istotalview = null;
        this.ishyperlinkview = null;
        this.isdisputeview = null;

        this.header_created_by = null;
        this.header_updated_by = null;
        this.header_created_dt = null;
        this.header_updated_dt = null;

        this.buttonid = null;
        this.buttonconfigid = null;
        this.button_position = null;
        this.button_name = null;
        this.button_pagenav = null;
        this.button_created_by = null;
        this.button_created_dt = null;
        this.button_updated_by = null;
        this.button_updated_dt = null;

        this.kpi_name = null;
        this.commission_plan = null;
        this.field_value = null;
    }
}